import { runDemo } from "../shared/demoRunner";
import { createEspilitScene } from "./scene";

runDemo({ createScene: createEspilitScene });
